



















import {defineComponent, PropType} from "@vue/composition-api";
import {BillingInterval, DefinedBillingPlan} from "@tool/Pages/App/Teams/Billing/billing.types";
import {formatPrice} from "@tool/Pages/App/Teams/Billing/billing.helpers";

export default defineComponent({
    emits: ['subscribe'],
    props: {
        plan: {
            type: Object as PropType<DefinedBillingPlan>,
            required: true
        },
        buttonText: {
            type: String,
            default: 'SUBSCRIBE'
        }
    },
    setup(props, {emit}) {
        const formSubmit = (interval: BillingInterval) => {
            emit('subscribe', interval, props.plan);
        }

        return {
            formSubmit,
            formatPrice
        };
    }
});
